.imageWrapper {
  position: relative;
  overflow: hidden;
}

.overlay {
  pointer-events: none;
}

.image {
  object-fit: cover;
  transition: transform 0.2s;
  cursor: pointer;
  &:hover {
    transform: scale(1.05);
  }
}
